module.exports = __webpack_public_path__ + "static/media/battery_eng_01.1197ffc1.png";